const SESSION_LIMIT = 59 * 60 * 1000; // 59 minutos
//const SESSION_LIMIT = 20000; // 1 minuto

export function LogInCall(token) {
  localStorage.setItem("datosm", token);
  refreshSessionActivity(); 
}

export function LogInShare(user) {
  localStorage.setItem("sharem", user);
}

export function DelateLogin() {
  localStorage.removeItem("sharem");
  localStorage.removeItem("datosm");
  localStorage.removeItem("lastActivity");
}

export function refreshSessionActivity() {
  localStorage.setItem("lastActivity", String(Date.now()));
}

export function isSessionValid() {
  const token = localStorage.getItem("datosm");
  const lastActivity = Number(localStorage.getItem("lastActivity"));

  if (!token || !lastActivity) return false;

  if (Date.now() - lastActivity > SESSION_LIMIT) {
    DelateLogin();
    return false;
  }

  return true;
}

export function logoutByExpiredSession(message = "Tiempo de sesión expirado, vuelva a iniciar sesión.") {
    try {
      localStorage.setItem("toast_after_login", message);
      DelateLogin();
    } catch (e) {}
  
    if (window.location.pathname !== "/") {
      window.location.href = "/";
    }
  }
